export default {  
  text: 'Your text',
  variant: 'bodyText',
  color: undefined
}
